import request from '@/utils/request'

// 分类模块

// 贴子详情
export function detailsxq(data) {
  return request({
    url: `/invitation/infot/${data}`,
    method: 'get'
  })
}
// 分页查询贴子评论
export function detailscomments(data) {
  return request({
    url: '/comment/reply/page',
	method: 'post',
	data:data
  })
}
// 查询相同组类型贴子 上一页下一页
export function tielie(data) {
  return request({
    url:  `/invitation/info/${data.gid}/?pageNum=${data.ye}&pageSize=${data.jitiao}`,
	method: 'get'
  })
}
// 发布评论
export function fabucomment(data) {
  return request({
    url:'/comment/',
	method: 'post',
	data:data
  })
}
// 点赞帖子评论
export function pinglundianzan(data) {
  return request({
    url:`/collection/giveLikes`,
	method: 'post',
	data:data
  })
}
// 点赞帖子
export function tiezidianzan(data) {
  return request({
    url:`/collection/giveLike`,
	method: 'post',
	data:data
  })
}
// 收藏帖子
export function tiezishoucang(data) {
  return request({
    url:`/collection`,
	method: 'post',
	data:data
  })
}
// 打赏帖子
export function tiezidashang(data) {
  return request({
    url:`/member/user/reward/`,
	method: 'post',
	data:new URLSearchParams(data).toString()
  })
}
//管理员操作
export function guanliplzhiding(data) {
  return request({
    url:`/comment/topping/${data.id}/${data.available}`,
	method: 'post',
	// data:new URLSearchParams(data).toString()
  })
}
export function guanliplshanchu(data) {
  return request({
    url:`/comment/delete/${data.id}`,
	method: 'post',
	data:new URLSearchParams(data).toString()
  })
}
export function guanliplyingcan(data) {
  return request({
    url:`/comment/hidden/${data.id}/${data.available}`,
	method: 'post',
	data:new URLSearchParams(data).toString()
  })
}
